export interface Input extends Marko.HTML.Img {}

<const/{ class: className, ...attrs }=input>

<img class=["img-fluid mx-auto", className] ...attrs>
